/**
 * Services
 * @module securityCodeService
 */
define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.securityCodeService = function ($http, lpCoreUtils) {
        var ctrl = this;

        ctrl.getSecurityCode = function(userName) {
            var params = {
                user_name: userName
            };
            
            return $http.get(lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/v1/authentication/session/seed'), {
                    params: params
                });
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/services/securityCodeService.js